import React from 'react';
import PropTypes from 'prop-types';

function PreviousArrow(props) {
  const {
    className,
    onClick,
    children,
    currentTab,
    wrapBackwardFromPrev,
    isHomepageCarousel,
  } = props;

  const isAtStart = currentTab === 0;
  const isSlickDisabled = className && className.includes('slick-disabled');
  const shouldDisable = isAtStart || isSlickDisabled;

  const handleClick = (e) => {
    if (shouldDisable) {
      e.preventDefault();
      return;
    }
    onClick?.(e);
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Tab' && e.shiftKey) {
      if (typeof wrapBackwardFromPrev === 'function') {
        e.preventDefault();
        wrapBackwardFromPrev();
      }
    }
  };

  return (
    <button
      type="button"
      className={className}
      aria-label="Slide anterior do carrossel"
      aria-disabled={shouldDisable}
      disabled={shouldDisable}
      onClick={handleClick}
      tabIndex={isHomepageCarousel && shouldDisable ? -1 : 0}
    >
      {children}
    </button>
  );
}

PreviousArrow.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
  onClick: PropTypes.func,
  currentTab: PropTypes.number,
  isHomepageCarousel: PropTypes.bool,
  wrapBackwardFromPrev: PropTypes.func,
};

// TODO(next16): defaultProps removed in React 19 for function components.
// Convert to inline parameter defaults: const PreviousArrow = ({prop = val, children = <span className="glyphicon glyphicon-chevron-left" />, onClick = () => null }) =>

export default PreviousArrow;